import { useParams, useSearchParams } from 'react-router-dom';
import usePageDataStore from 'stores/pageDataStore';
import { capitalize } from '../utils/utils';
import {
  filterStyleAndCategoryMetaDataTitle,
  filterStyleMetaDataDescription,
  filterStyleMetaDataTitle,
  keyForTheMetaDescription,
} from '../data';

const useUpdateMetaData = () => {
  const { page } = useParams();
  const [query] = useSearchParams();
  const { pageData, setPageData } = usePageDataStore(state => ({
    pageData: state.pageData,
    setPageData: state.setPageData,
  }));
  const filterStyle = capitalize(query.get('style'));
  const landingName = pageData?.data.name;

  const updateMeta = () => {
    let metaDataDescription = pageData?.data.seoSettings?.ogDescription;
    let metaTitle = pageData?.data.seoSettings?.ogTitle;
    let metaDescription = metaDataDescription;
    if (!page && filterStyle) {
      metaTitle = `${filterStyle} ${metaTitle}`;
      metaDataDescription = filterStyleMetaDataDescription.replace('[style]', filterStyle);
    }

    if (filterStyle) {
      if (page) {
        metaTitle = metaTitle
          ?.replace(landingName, `${filterStyle} ${landingName}`)
          .replace(
            filterStyleAndCategoryMetaDataTitle,
            `${filterStyle} ${filterStyleAndCategoryMetaDataTitle}`,
          );
        metaDescription = metaDataDescription?.replace(
          keyForTheMetaDescription,
          `${keyForTheMetaDescription} ${filterStyle}`,
        );
      } else {
        metaTitle = filterStyleMetaDataTitle.replace('[style]', filterStyle);
        metaDescription = filterStyleMetaDataDescription.replace('[style]', filterStyle);
      }
      setPageData({
        ...pageData,
        data: {
          ...pageData.data,
          seoSettings: {
            ...pageData?.data.seoSettings,
            title: metaTitle,
            metaDescription,
            canonicalUrl: window.location.href,
          },
        },
      });
    }
  };

  return { updateMeta };
};

export default useUpdateMetaData;
